import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaStavkaDodatniAtribut extends BaseEntity{
    constructor(){
        super();
    }   
    EOtpremnicaStavkaID: number = null;
    Naziv: string=null;
    Vrednost: string=null;

    Deserialize(input:any){  
        super.Deserialize(input);
        this.ID=input.ID;
        this.EOtpremnicaStavkaID=input.EOtpremnicaStavkaID;
        this.Naziv=input.Naziv;
        this.Vrednost=input.Vrednost;
        return this;
    }

    Serialize(input:EOtpremnicaStavkaDodatniAtribut){
        return input;
    }
}